import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';

import useStyles from './input.styles';

const Input: React.FC<TextFieldProps> = ({ variant, size, children, ...restProps }) => {
  const css = useStyles();
  const userVariant = variant || 'outlined';
  const userSize = size || 'small';

  return (
    <TextField
      {...restProps}
      variant={userVariant}
      size={userSize}
      InputLabelProps={{
        ...restProps.InputLabelProps,
        classes: {
          root: css.label,
          shrink: css.shrink,
          focused: css.labelFocused,
          marginDense: css.marginDenseLabel,
          asterisk: css.labelAsterisk,
        },
      }}
      InputProps={{
        ...restProps.InputProps,
        classes: {
          root: css.input,
          error: css.error,
          input: css.baseInput,
        },
      }}
    >
      {children}
    </TextField>
  );
};

export default Input;
